import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatDate, formatMoney } from "../Helpers";

export default function View({ data, type, studentUuid }) {

  const appContext = useContext(AppContext);

  /* Place states here */

  function viewDebt() {
    appContext.navTo({
      item: 'side-view',
      subItem: 'debt-options',
      extraItem: data.uuid,
    });
  }

  function collectPayment() {
    appContext.navTo({
      item: 'side-view',
      subItem: 'debt-collections',
      extraItem: data.uuid,
      moreItem: studentUuid,
    });
  }

  return (
    <div className="One">
      <div className="row">

        <div className="col-12">
          <h6
            style={{
              fontSize: "16px"
            }}
            className="font-semi-bold"
          >
            {data.title}
          </h6>
        </div>
        
        <div className="col-6 mt-2 mb-2">
          <h6
            style={{
              fontSize: "20px"
            }}
            className="font-semi-bold text-success"
          >
            {formatMoney(data.amountPaid)}
            <span style={{ fontSize: "12px" }} className="d-block">Paid (TZS)</span>
          </h6>
        </div>

        <div className="col-6 mt-2 mb-2 text-end">
          <h6
            style={{
              fontSize: "20px"
            }}
            className="font-semi-bold text-danger"
          >
            {formatMoney(data.balance)}
            <span style={{ fontSize: "12px" }} className="d-block">Unpaid (TZS)</span>
          </h6>
        </div>

        <div className="col-12 mt-2 mb-2 text-end">
          <button
            className="btn btn-sm btn-outline-dark m-1"
            onClick={viewDebt}
          >
            View Debt
          </button>

          {
            (Number(data.balance) > 0) ?
            <button
              className="btn btn-sm btn-outline-primary m-1"
              onClick={collectPayment}
            >
              Collect Payments
            </button>
            :""
          }
        </div>

      </div>
    </div>
  )

}